import { useQuery } from '@tanstack/react-query';
import { fetchAssignedProducts } from '../services/productAddons';

export function useAddOnAssignedProductsQuery(addOnId: string | undefined) {
    return useQuery({
        queryKey: ['smr-admin', 'addon', 'assigned-products', addOnId ?? ''],
        queryFn: () => fetchAssignedProducts(addOnId!),
        enabled: !!addOnId,
    });
}
